import type { AxiosRequestConfig } from 'axios';
import { getConfig } from '@/configProvider';
import { webApiUrlStariiMap } from '@/utils/env';
import request from '@/utils/request';

export const fopCreate = (data: { url: string; save_type: string; fops: string }) => {
    const { isIntl, env, appName } = getConfig();

    let requestConfig: AxiosRequestConfig = {};

    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === 'x-design') {
        if (env === 'pre') {
            requestConfig.baseURL = webApiUrlStariiMap['beta'];
        }
    }

    return request.post<any, { task_id: string }>('/v1/fop/create', data, requestConfig);
};

export type QueryRes = {
    status: number; // 状态 1 进行中 2 成功 3 失败
    err_msg: string; // 状态为3时 返回失败原因 例如 执行失败、超时
    url: string;
};

export const fopQuery = (params: { task_id: string }) => {
    const { isIntl, env, appName } = getConfig();

    let baseURL;

    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === 'x-design') {
        if (env === 'pre') {
            baseURL = webApiUrlStariiMap['beta'];
        }
    }

    return request.get<any, QueryRes>('/v1/fop/query', { params, baseURL });
};

/**
 * 获取obs app 配置
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/153151
 * @returns
 */
interface ObsConfigResponse {
    app: string; // obs app
    sig: number; // 是否签名 1:是 0:否
    config: {
        partSize?: number; // 分片大小 byte
        concurrency?: number; // 分片并发请求数，默认0，前端走默认值
    };
}
export const fetchObsConfig = async (params: { oid?: string; project?: string }) => {
    return request<any, ObsConfigResponse>({
        method: 'GET',
        url: '/v1/obs_config/get_app',
        params,
        hiddenMessage: true,
    });
};
